import { useState, useEffect } from 'react';

export const useModal = (initialState = false) => {
  const [isOpen, setIsOpen] = useState(initialState);
  
  const openModal = () => {
    setIsOpen(true);
    document.body.style.overflow = 'hidden'; // Prevent scrolling
  };
  
  const closeModal = () => {
    setIsOpen(false);
    document.body.style.overflow = ''; // Re-enable scrolling
  };
  
  // Make sure we clean up the body style if the component unmounts while modal is open
  useEffect(() => {
    return () => {
      if (isOpen) {
        document.body.style.overflow = '';
      }
    };
  }, [isOpen]);
  
  return { isOpen, openModal, closeModal, toggleModal: () => setIsOpen(!isOpen) };
};

export default useModal; 